

export type ClientSkinId='classic'|'warm'|'mono'|'sage'|'wine' | 'navy' | 'petrol' | 'taupe' | 'plum'
export const clientSkinColors:Record<ClientSkinId,string[]>={
  classic:['#1890FF','#00318C','#F3F7FC','#E4F1FF','#FFFFFF'],
  warm:['#9A662F','#493524','#F7F3EB','#F2E7D6','#FFFDF8'],
  mono:['#25272B','#202226','#F4F4F3','#E7E7E5','#FFFFFF'],
  sage:['#637B68','#344A3B','#F3F5EF','#E2E9DB','#FEFFF9'],
  wine:['#783A49','#4B2932','#F8F2F1','#EDDEE0','#FFFCFA'],
  navy: ["#344B69","#182739","#F2F5F8","#E1E8F0","#FCFDFF"],
  petrol: ["#3C6B6B","#1D383A","#F0F5F4","#DDEBE8","#FCFFFE"],
  taupe: ["#77685D","#3C342F","#F5F2EE","#E9E1D8","#FFFDFA"],
  plum: ["#65516D","#322A39","#F5F2F6","#E7DFEB","#FEFCFF"]
}
// 只在当前域名的机构资料完成校验后应用，不使用登录客户或旧缓存决定店铺。
export function resolveClientSkin(orgId:number,org:any,ready:boolean){
  let settings:any={}
  if(ready && Number.isSafeInteger(orgId) && orgId>=1000 && Number(org?.id)===orgId){
    try{settings=typeof org.settings==='string'?JSON.parse(org.settings):org.settings}catch{/* 缺省经典 */}
  }
  // 2026-10-25：网页独立读取本端皮肤；旧机构未分端配置时保留原配色及图片跟随行为。
  const theme=settings && Object.prototype.hasOwnProperty.call(settings,'webTheme')?settings.webTheme:settings?.miniappTheme
  let id:ClientSkinId=Object.prototype.hasOwnProperty.call(clientSkinColors,theme)?theme:'classic'
  if(ready && Number.isSafeInteger(orgId) && orgId>=1000 && Number(org?.id)===orgId){
    try{const saved=window.localStorage.getItem('ldy-client-skin:'+orgId);if(saved && Object.prototype.hasOwnProperty.call(clientSkinColors,saved))id=saved as ClientSkinId}catch{/* 存储不可用时沿用店铺设置。 */}
  }
  const follow=settings && Object.prototype.hasOwnProperty.call(settings,'webHomeImageFollowSkin')?settings.webHomeImageFollowSkin===true:settings?.homeImageFollowSkin===true
  return {id,colors:clientSkinColors[id],follow}
}
const homeIllustrationFilters:Record<ClientSkinId,string>={classic:'none',warm:'grayscale(1) sepia(1) saturate(.75) hue-rotate(-7deg)',mono:'grayscale(1)',sage:'grayscale(1) sepia(1) saturate(.55) hue-rotate(95deg)',wine:'grayscale(1) sepia(1) saturate(1.1) hue-rotate(307deg)',navy:"grayscale(1) sepia(1) saturate(.6) hue-rotate(170deg)",petrol:"grayscale(1) sepia(1) saturate(.55) hue-rotate(125deg)",taupe:"grayscale(1) sepia(.65) saturate(.45)",plum:"grayscale(1) sepia(1) saturate(.45) hue-rotate(255deg)"}
export function applyClientSkin(skin:ReturnType<typeof resolveClientSkin>,root=document.documentElement){
  root.dataset.clientSkin=skin.id
  // 默认矢量图直接用当前皮肤绘制；图片跟随开关只控制原有位图的配色处理。

  root.style.setProperty('--antd-wave-shadow-color',skin.colors[0])
  root.style.setProperty('--clientPrimary',skin.colors[0])
  root.style.setProperty('--clientPrimaryRgb',[1,3,5].map(offset=>parseInt(skin.colors[0].slice(offset,offset+2),16)).join(','))
  root.style.setProperty('--clientHomeImageFilter',skin.follow?homeIllustrationFilters[skin.id]:'none')
  root.dataset.homeImageFollow=String(skin.follow)
  root.style.setProperty('--clientHomeImageBlend',skin.follow?'luminosity':'normal')
  const names=['--activeColor','--clientHead','--clientCanvas','--clientSoft','--clientSurface']
  names.forEach((name,index)=>root.style.setProperty(name,skin.colors[index]))
  root.style.setProperty('--clientGradientEnd',skin.id==='classic'?'':skin.colors[1])
  if(typeof window!=='undefined')window.dispatchEvent(new Event('home-replica-skin'))
}

// 仅保存本浏览器、当前已验证机构的配色选择，不写商家配置。
export function selectClientSkin(orgId:number,org:any,id:ClientSkinId|null){
  if(!Number.isSafeInteger(orgId) || orgId<1000 || Number(org?.id)!==orgId)return false
  if(id!==null && !Object.prototype.hasOwnProperty.call(clientSkinColors,id))return false
  try{if(id===null)window.localStorage.removeItem('ldy-client-skin:'+orgId);else window.localStorage.setItem('ldy-client-skin:'+orgId,id)}catch{return false}
  applyClientSkin(resolveClientSkin(orgId,org,true))
  return true
}
